import React, { memo } from 'react'

import { Icon } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { arrayOf, elementType, shape, string } from 'prop-types'

import { iconSize } from 'Pods/ThreeDStudio/constants'
import List from 'Pods/ThreeDStudio/Shared/VariationInfo/Components/List/List'

function Details({ lines, variationType = undefined }) {
  return (
    <div className="variations-tree__details">
      {variationType && (
        <span className="variations-tree__type cgt-caption-semibold">
          <Icon notSpaced svgComponent={variationType.icon} color="dark" size={iconSize} />
          {variationType.label}
        </span>
      )}
      {lines.length > 0 && <List lines={lines} isCompact />}
    </div>
  )
}

Details.propTypes = {
  lines: arrayOf(string).isRequired,
  variationType: shape({
    icon: elementType,
    label: string,
  }),
}

export default memo(Details)
